// extracted by mini-css-extract-plugin
export default {"button":"hBU4WhxX9CinHm6pB35t","placeHolderShimmer":"Gty5jRu6n9DqMldKJtfa"};